<template>
    <div class="freeVipInfo" v-if="showFreeVipInfo">
			<div class="freeVipInfoBox">
                <img src="@/assets/images/vip/tryBg.png" alt="">
				<i class="el-icon-close" @click="closeFreeVipInfo"></i>
				<div class="infoBox">
                    <div class="mainTitle">尊敬的用户，您的会员体验特权到期</div>
                    <div class="mainDesc">为了享受更多权益和服务，请购买会员以享受更多服务</div>
                    <div class="vipBox">
                        <div class="vipRightBox">
                            <p class="title">开通{{ispower?'至尊':''}}会员免费使用</p>
                            <p class="desc" v-if="!ispower">开通会员畅享海量文件数</p>
                            <div class="modelBox" v-if="!ispower">
                                <div>
                                    <img src="~/assets/images/vip/file.png" alt="">
                                    <p>不限文件数量</p>
                                </div>
                                <div>
                                    <img src="~/assets/images/vip/model.png" alt="">
                                    <p>海量模板</p>
                                </div>
                            </div>
                            <div class="modelBoxs" v-if="ispower">
                                <div>
                                    <img src="~/assets/images/vip/icon1.png" alt="">
                                    <p>识别招标文件</p>
                                </div>
                                <div>
                                    <img src="~/assets/images/vip/icon2.png" alt="">
                                    <p>秒数生成公告</p>
                                </div>
                                <div>
                                    <img src="~/assets/images/vip/icon3.png" alt="">
                                    <p>多平台一键直达</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="buttonBox">
                        <el-button class="button" type="warning" @click="buyMember">优惠购买</el-button>
                        <el-button class="button" type="primary" @click="getSedToken" v-if="!ispower">继续前往</el-button>
                    </div>
                </div>
			</div>
		</div>
</template>

<script>
import { mapGetters } from 'vuex';
    export default {
        props:{
            ispower:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return{
                showFreeVipInfo: false, 
            }
        },
        computed: {
            ...mapGetters({
                userinfo: 'userinfo/getData',
            }),
        },
        methods:{
            // 打开弹窗
            openFreeVipInfo(){
                this.showFreeVipInfo= true
            },
            //关闭弹窗
            closeFreeVipInfo(){
                this.showFreeVipInfo= false
                this.$emit("close")
            },
            //检测用户会员是否过期
            checkUserState(){
                this.$get(`${this.$store.state.api.webUrl}/uservip/isVipExpire.json`,
                    (data) => {
                        if(data.result){ //如果过期
                            this.showFreeVipInfo= true
                        }else{ //没有过期
                            this.getSedToken()
                        }
                    }
                );
            },

            //过期之后的弹窗中的操作
            buyMember(){
                this.closeFreeVipInfo()
                window.location.href=`/user/assets/vip?vipType=${this.ispower ? 'super_vip' : 'year_vip'}&redirectUrl=${encodeURIComponent(window.location.href)}`
            },

            getSedToken() {
                this.$ajax({
                    type: 'get',
                    url: `${this.$store.state.api.baseWebUrl}/yzkj/login/token`,
                    callback: data => {
                        let targetUrl = `${this.$store.state.api.yzkjTemplate}/#/login?token=${data}&path=online`
                        window.open(targetUrl)
                    }
                });
        },
        
        },
        mounted(){
          
        }
    }
</script>

<style lang="scss" scoped>
     .freeVipInfo {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2201;
        .freeVipInfoBox {
            position: relative;
            width: 643px;
            height: 472px;
            border-radius: 10px;
            background: #fff;
            i {
                position: absolute;
                font-size: 40px;
                right: -40px;
                top: -20px;
                color: white;
                cursor: pointer;
            }
            img{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 472px;
                z-index: 1;
            }
            .infoBox{
                text-align: center;
                z-index: 5;
                .mainTitle{
                    font-size: 22px;
                    color: #141414;
                    margin-top: 29px;
                }
                .mainDesc{
                    font-size: 18px;
                    color: #555;
                    margin-top: 10px;
                }
                .vipBox{
                    width: 546px;
                    height: 240px;
                    margin: 0 auto;
                    margin-top: 27px;
                    display: flex;
                    justify-content: space-between;
                    .title{
                        color: #1d1d1d;
                        font-size: 18px;
                    }
                    .vipLeftBox{
                        width: 226px;
                        height: 240px;
                        border-radius: 8px;
                        padding: 12px 0;
                        background-color: #fff;
                        .money{
                            color: #FF4D30;
                            font-size: 32px;
                            span{
                                font-size: 22px;
                                margin-right: 4px;
                            }
                        }
                        img{
                            position: static;
                            width: 122px;
                            height: 122px;
                        }
                        .tips{
                            color: #2D2D2D;
                            font-size: 14px;
                        }
                    }
                    .vipRightBox{
                        width: 100%;
                        height: 240px;
                        border-radius: 8px;
                        padding: 12px 0;
                        background-color: #fff;
                        .desc{
                            font-size: 18px;
                            color: #676767;
                            margin-top: 9px;
                        }
                        .modelBox{
                            width: 186px;
                            margin: 0 auto;
                            margin-top: 39px;
                            display: flex;
                            justify-content: space-between;
                            color: #1d1d1d;
                            img{
                               position: static;
                               width: 60px;
                               height: 60px; 
                               margin-bottom: 10px;
                            }
                        }
                        .modelBoxs{
                            width: 420px;
                            margin: 0 auto;
                            margin-top: 50px;
                            display: flex;
                            justify-content: space-between;
                            color: #1d1d1d;
                            img{
                               position: static;
                               width: 60px;
                               height: 60px; 
                               margin-bottom: 10px;
                            }
                        }
                    }
                }
                .buttonBox {
                    width: 546px;
                    text-align: center;
                    display: flex;
                    justify-content: space-around;
                    margin: 0 auto;
                    margin-top: 27px;
                    .button {
                        width: 200px;
                        height: 50px;
                        border-radius: 28px;
                        font-size: 18px;
                    }
                }
            }
        }
     }
</style>